export default {
  getChannels: state => state.channels,
}
